import { useState } from 'react';
import { FaHeart, FaRegHeart } from 'react-icons/fa6';
import { NavLink, useNavigate, useLocation, Link, useParams } from "react-router-dom"
import { modelImagePath } from '../../utils/constants';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const FlashSaleItem = ({ item }) => {
    const [liked, setLiked] = useState(false);

    return (
        <div className="flash-card position-relative me-3 flex-shrink-0 p-2 bg-white rounded shadow-sm text-center">
            <button
                className="like-btn position-absolute top-0 end-0 m-2 btn p-0 border-0 bg-transparent"
                onClick={() => setLiked(!liked)}
                title={liked ? 'Remove from wishlist' : 'Add to wishlist'}
            >
                {liked ? <FaHeart className="text-danger" /> : <FaRegHeart className="text-secondary" />}
                {/* {liked ? 'Heart' : 'Heart Outline'} */}
            </button>

            <NavLink to={`/product/${item.slug}`} className="text-decoration-none text-dark">
                <img
                    src={`${item.img}`}
                    alt={item.title}
                    className="img-fluid mb-2"
                    style={{ height: '100px', objectFit: 'contain' }}
                />
                <div className="fw-bold small">{item.title}</div>
                <div className="text-danger small fw-semibold">{item.price}</div>
                <div className="text-muted small text-decoration-line-through">{item.originalPrice}</div>
                <span className="badge bg-success mt-1">{item.discount}</span>
            </NavLink>
        </div>
    );
};
export default FlashSaleItem;